import { Menu } from 'lucide-react';
import { useNavigate } from 'react-router';
import { useUiStore } from '../../core/stores/uiStore.js';
import { useAuthStore } from '../../core/stores/authStore.js';
import { Avatar } from '../ui/Avatar.jsx';

export function AppHeader() {
  const navigate = useNavigate();
  const toggleMenu = useUiStore((s) => s.toggleMenu);
  const currentUser = useAuthStore((s) => s.currentUser);

  return (
    <header className="glass fixed top-0 left-0 right-0 z-50 px-3 pb-2 pt-[max(0.5rem,env(safe-area-inset-top))] md:hidden">
      <div className="mx-auto flex max-w-3xl items-center justify-between">
        <button
          type="button"
          onClick={toggleMenu}
          className="flex h-11 w-11 shrink-0 items-center justify-center rounded-full text-brand transition-colors hover:bg-brand/5 min-h-0 min-w-0"
          aria-label="Open menu"
        >
          <Menu className="h-6 w-6" strokeWidth={2} />
        </button>

        <button
          type="button"
          onClick={() => navigate('/')}
          className="absolute left-1/2 -translate-x-1/2 min-h-0 min-w-0 px-2"
        >
          <img
            src="/images/LogoDark.png"
            alt="Yocas"
            className="h-10 w-auto max-w-[40vw] object-contain"
          />
        </button>

        <button
          type="button"
          onClick={() => navigate('/profile')}
          className="ml-auto shrink-0 min-h-0 min-w-0"
          aria-label="My profile"
        >
          <Avatar
            src={currentUser?.profilePictureUrl}
            name={currentUser?.name || ''}
            size="sm"
            className="h-[35px] w-[35px]"
          />
        </button>
      </div>
    </header>
  );
}
